import { render, staticRenderFns } from "./SmallFooter.vue?vue&type=template&id=0b7176fb"
import script from "./SmallFooter.vue?vue&type=script&lang=js"
export * from "./SmallFooter.vue?vue&type=script&lang=js"
import style0 from "./SmallFooter.vue?vue&type=style&index=0&id=0b7176fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports